<template>
  <drag-modal :visible="$store.state.dislog.beforetime" @cancel="reset" :title='"添加进度-" + litetit'
    :class='{ "editbox": Edit }' width='860px'>
    <div class="navbox" v-if='Edit'>
      <Nscroll @getIndex='see' @delCopy='copydel' :openEdit='openEdit'></Nscroll>
      <div class="intopbtn" v-if='!isAllDis'>
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
                <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
              </a-popconfirm> -->
        <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
          step != 181 && $store.state.DisForm.infoList &&
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
        ">
          <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
        </a-popconfirm>
        <a-button icon="edit"
          v-if='$common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) && $store.getters.publicPower'
          style="margin-left:10px;" @click='openEdit = !openEdit'>{{ openEdit ? "修改" : "取消修改" }}</a-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="移交时间" prop="turn_date"
                :rules="{ required: true, message: '请选择移交时间', trigger: 'change' }" labelAlign="left">
                <a-date-picker v-model="form.turn_date" :placeholder="!openEdit ? '请选择移交时间' : ''" format='YYYY-MM-DD'
                  type="date" valueFormat="YYYY-MM-DD HH:mm:ss" :disabled='openEdit' style="width: 100%;" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="移交人" prop="turn_uname"
                :rules="{ required: true, message: '请输入移交人', trigger: 'blur' }" labelAlign="left">
                <a-input v-model="form.turn_uname" :placeholder="!openEdit ? '请输入移交人' : ''" :disabled='openEdit' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="接收人" prop="receive_uname"
                :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }" labelAlign="left">
                <a-input v-model="form.receive_uname" :placeholder="!openEdit ? '请输入接收人' : ''" :disabled='openEdit' />
              </a-form-model-item>
            </a-col>
          </a-row>
          <div>
            <div class="licter" v-if="!openEdit">
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon" style="margin-bottom:5px;">
              <div class="ilikebox" v-for="(i, index) in form.supp" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    补充材料：电子
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    补充材料：微信
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    补充材料：现场
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入补充提交人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" placeholder="请输入补充提交人" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    补充材料：邮寄
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入收件人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" placeholder="请输入收件人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">
                          {{
                            i.gout == 'a'
                              ? '签收时间:'
                              : i.gout == 'b'
                                ? '拒收时间:'
                                : '无'
                          }}
                        </label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" style="white-space: nowrap" size="small"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 0.75rem;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-date-picker disabled v-if="!i.gout" placeholder=""
                          :value="i.receive_time || i.return_time || ''" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                        <!-- <a-input disabled v-if="!i.gout" /> -->
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'" :rules="{
                        required: true,
                        message: '请输入收件地址',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.addr" :disabled="openEdit" type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>

            <div class="licter" v-if="!openEdit">
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for="(i, index) in form.accept_file" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    接收材料：电子
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    接收材料：微信
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    接收材料：现场
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    接收材料：邮寄
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" size="small" style="white-space: nowrap"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 0.75rem;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'" :label-col="{ span: 12 }"
                        :wrapper-col="{ span: 24 }" :rules="{
                          required: true,
                          message: '请输入收件地址',
                          trigger: 'blur',
                        }">
                        <a-input v-model="i.addr" :disabled="openEdit" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'"
                        :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
                        <a-input v-model="i.comment" :disabled="openEdit" placeholder="" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item label="备注" prop="comment" v-if='!loading' labelAlign="left">
            <Textarea :content='form.comment' @contentVal='(element) => { form.comment = element }' :edit='openEdit'
              :keyArr="['time', 'user']"> </Textarea>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top:20px;" :label-col="{ span: 3 }">
            <Upload :fList='List' @isDisabled="parentHandle" @upFileAfter='(element) => { form.files = element }'
              :disabled="openEdit" :edit='openEdit' v-if='!loading' />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if='!openEdit' style="text-align:center;">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button :disabled="disabledShow" type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>
</template>

<script>
const formItem = {
  "turn_date": '',
  "turn_uname": '',
  "receive_uname": '',
  "comment": [{}],
  "files": [],
  supp: [],
  accept_file: [],
}
import Nscroll from "@/components/nscroll"
import Upload from "@/components/uploads"
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  jzyjAdd,
  jzyjEdit,
  jzyjLists, delJd
} from "@/server/speed"
import Textarea from "@/components/textarea"
export default {
  name: 'Beforetime',
  computed: {
    ...mapGetters([
      'litetit',
      'Edit'
    ]),
  },
  components: {
    Textarea,
    Upload,
    Nscroll
  },
  data() {
    return {
      List: [],
      isAllDis: this.$route.query.t,
      form: JSON.parse(JSON.stringify(formItem)),
      step: this.$store.state.StepLite,
      rules: {},
      loading: true,
      openEdit: false,
      disabledShow: false
    }
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        jzyjLists({
          cause_id: this.$store.state.cause.id,
          step: this.step
        }).then(e => {
          e.list.map(ele => {
            // ele.jzyj.supp = Object.keys(ele.jzyj.supp).map(key => ele.jzyj.supp[key])
            ele.jzyj.supp = Object.keys(ele.jzyj.supp).map(key => {
              const item = ele.jzyj.supp[key];

              // 添加 gout 属性
              item.gout = item.receive_time ? 'a' :
                item.return_time ? 'b' :
                  null;

              return item;
            });
            ele.jzyj.accept_file = Object.keys(ele.jzyj.accept_file).map(key => {
              const item = ele.jzyj.accept_file[key];

              // 添加 gout 属性
              item.gout = item.receive_time ? 'a' :
                item.return_time ? 'b' :
                  null;

              return item;
            });
            // ele.jzyj.accept_file = Object.keys(ele.jzyj.accept_file).map(key => ele.jzyj.accept_file[key])

            ele.jzyj.comment = !ele.jzyj.comment || (ele.jzyj.comment && ele.jzyj.comment.length == 0) ? [{}] : ele.jzyj.comment
          })
          this.Infokey({
            key: 'infoList',
            value: e.list
          })
          this.$store.dispatch("settime", e.list[0].jzyj.update_time)
          this.see(0)

        })

        this.openEdit = true;
      })

    } else {
      this.loading = false;
    }
  },
  methods: {
    parentHandle(data) {
      this.disabledShow = data
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove'
    }),
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) { //删除进度
      await this.Newdel({
        index: index,
        formKey: ["turn_date", "turn_uname", "receive_uname", "comment"],
        valkey: "jzyj"
      }).then(e => {
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd = this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ? true : false //当前是否是在修改下的新增
          if (form.files && form.files.length > 0) {
            form.files = form.files.map(ele => {
              return ele.upload_id || ele
            })
          }
          form.supp.map(ele => {
            if (ele.type == 4) {

              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              // delete ele.gout
            }
          })

          form.accept_file.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              // delete ele.gout
            }
          })
          form.comment = form.comment.filter(ele => { return ele.content })
          if (this.Edit && !isEditCopyAdd) { //修改
            let step_id = this.$store.state.DisForm.infoList[curIndex].jzyj.id

            form.id = step_id;
            jzyjEdit(form).then(e => {
              this.$message.success({
                content: '修改成功',
                key: 'updatable'
              });
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.openEdit = true;
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            jzyjAdd(form).then(e => {
              this.$message.success({
                content: '新增成功',
                key: 'updatable'
              });
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async see(index) { //查看切换 审批
      this.loading = true;
      this.seeInfo({
        index: index,
        formKey: ["turn_date", "turn_uname", "receive_uname", "comment", 'supp', 'accept_file'],
        valkey: "jzyj"
      }).then(e => {
        let form = JSON.parse(JSON.stringify(e));
        form.files.map((ele) => {
          ele.title = ele.origin_name || ele.title
          ele.upload_id = ele.upload_id
          ele.id = ele.id
        })
        this.List = form.files
        this.form = form
        this.loading = false;
      })
    },
    reset() {
      this.reMove().then(e => {
        this.$refs.forms.resetFields();
        this.$store.dispatch('openkey', {
          key: 'beforetime',
          by: false
        })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  }
}
</script>

<style lang="less" scoped>
.ilikecon {
  max-height: 400px;
  overflow: auto;
}

.intopbtn .rd {
  opacity: 0.8;
  border-color: #ff9800;
  color: #ff9800;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-form-item-label {
    text-align: left;
  }
}

.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: right;
    width: 60px;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
</style>